import { useStaticQuery, graphql } from 'gatsby';
import moment from 'moment';
import React from 'react';

import * as style from './footer.module.less';

export default () => {
  const data = useStaticQuery(graphql`
  query {
    currentBuildDate {
      currentDate
    }
  }
`);
  const { currentBuildDate: { currentDate } } = data;
  const buildTime = moment(currentDate).format('MMM Do YYYY');
  return (
    <footer className={style.footer}>
      {`Last updated ${buildTime}`}
    </footer>
  );
};
